import { render } from "./AnimatedSvg.vue?vue&type=template&id=012604c8"
import script from "./AnimatedSvg.vue?vue&type=script&lang=js"
export * from "./AnimatedSvg.vue?vue&type=script&lang=js"

import "./AnimatedSvg.vue?vue&type=style&index=0&id=012604c8&lang=scss"
script.render = render

export default script